import styled from 'styled-components';
import tw from 'twin.macro';

import { colors } from '@nw/shared/ui';

export const FormFieldSet = styled.fieldset`
  ${tw`flex flex-col items-center justify-start w-full h-full`};
`;

export const MultiStepFormFooterWrapper = styled.div`
  ${tw`flex flex-grow-default justify-end flex-col w-full items-center mt-24px`}
`;

export const GoBackContainer = styled.button`
  ${tw`flex justify-center items-center cursor-pointer self-start font-inter pb-6`};

  * {
    pointer-events: none;
  }
`;

export const GoBackText = styled.span`
  ${tw`font-inter text-sm leading-5 font-normal ml-1 text-lightBlueGray`};
`;

export const OTPDescriptionText = styled.span`
  ${tw`text-sm leading-5 font-normal font-inter self-start text-blue-gray-500 mt-2 mb-2`}
`;

export const PhoneNumberText = styled.span`
  ${tw`font-inter text-sm font-semibold leading-5`}
  color: ${colors.blackCoral};
`;

export const ErrorMessage = styled.span`
  ${tw`text-xs mt-1 text-red-600 font-normal leading-4`}
`;

export const SuccessMessageContainer = styled.div`
  ${tw`flex flex-col items-center self-center w-full`}
`;

export const SuccessDescription = styled.div`
  ${tw`text-base font-inter leading-6 mb-6 font-medium`};
  color: var(--light-blue-gray-500, #64748b);

  @media (max-width: 768px) {
    ${tw`text-sm leading-5`}
    margin-bottom: 16px;
  }
`;

export const IconContainer = styled.div`
  ${tw`flex justify-center items-center`}
`;

export const LineBreak = styled.div`
  ${tw`h-1px w-full my-4 mx-0`};
  background: #cbd5e1;
`;

export const SuccessHeading = styled.p`
  ${tw`text-2xl leading-8 font-semibold mb-4 mt-4 font-inter`};
  color: #334155;
  @media (max-width: 768px) {
    ${tw`text-lg leading-7 mt-6`}
  }
`;

export const ProgressBarContainer = styled.div`
  ${tw`w-full bg-blue-gray-200`}
`;

export const ProgressBar = styled.div`
  ${tw`bg-blue-gray-600 h-6px rounded-tr-full rounded-br-full`}
  ${(props) => `width: ${props.width}%`};
`;

export const LimitedSeatMessageContainer = styled.div`
  ${tw`flex flex-row items-center gap-4px h-5 mb-16px p-0 flex-nowrap `};
  width: 175px;
`;
export const LimitedSeatMessageText = styled.span`
  ${tw`text-orange-600 font-inter font-medium text-14px leading-5`}
`;

export const FormTitle = styled.div``;

export const FormDescription = styled.div``;

export const TnCText = styled.p`
  font-family: HKGrotesk;
  font-stretch: normal;
  font-style: normal;
  line-height: 1rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: rgba(71, 85, 105);
  margin-top: 0.5rem;
`;
export const SubmitButtonTextWrapper = styled.div``;
export const SubmitButtonText = styled.div``;
export const SubmitButtonFrame = styled.div`
  display: none;
`;

export const CustomUIImage = styled.img`
  ${tw`w-full h-full mb-4`}
  ${(props) => props.css}
`;

export const AdditionalCTAButton = styled.button`
  ${tw`px-24px py-8px rounded-10px bg-transparent text-blue-600 flex justify-center items-center text-14px outline-none mt-1`};
`;

export const ExtraFooterUIContainer = styled.div`
  ${tw`flex flex-row justify-between items-stretch gap-16px w-full self-stretch`}
`;

export const LimitedTimeOfferContainer = styled.div`
  ${tw`flex flex-col gap-10px justify-end flex-1`}

  @media (max-width: 768px) {
    display: none;
  }
`;

export const CTAAndSubmitButtonContainer = styled.div`
  ${tw`flex flex-col justify-center items-center gap-12px flex-1`}
`;

export const PriceContainer = styled.div`
  ${tw`flex flex-row items-center gap-4px self-stretch`}
  font-size: 24px;

  .free-plan-offer {
    font-family: 'Satoshi Variable', sans-serif;
    font-weight: 700;
    color: #8b5cf6;
  }

  .striked-amount {
    font-family: 'Satoshi Variable', sans-serif;
    font-weight: 500;
    color: #f5f3ff;
    opacity: 0.5;
    text-decoration: line-through;
  }
`;
